<template>
    <modal name="VolunteerMinuteModal"
           @before-open="beforeOpen"
           transition="nice-modal-fade"
           :min-width="320"
           :min-height="150"
           :max-width="500"
           :pivot-y="0.4"
           :adaptive="true"
           :reset="true"
           height="auto"
           width="40%"
           :scrollable="true"
           classes="popupcontainer"
    >
        <div class="popupcontainer vue-dialog">
            <div class="btn-close">
                <svg width="14px" height="14px" viewBox="0 0 12 12" xmlSpace="preserve" @click="cancel()">
                    <line x1="1" y1="11" x2="11" y2="1" style="stroke-linecap: round; stroke-linejoin: round;"></line>
                    <line x1="1" y1="1" x2="11" y2="11" style="stroke-linecap: round; stroke-linejoin: round;"></line>
                </svg>
            </div>
            <div class="modalHeader">
                <h4>봉사시간 {{ isFirst ? '부여' : '수정' }}</h4>
            </div>

            <div style="padding: 1.5em;" class="modal-body">
                <p><b>{{ article.memberName }}</b> 님에게 부여할 봉사시간(분)을 입력하세요.</p>
                <div class="input-group">
                    <input type="number" min="0" class="form-control" v-model.number="minute" @keyup.enter="submit()">
                    <div class="input-group-append">
                        <span class="input-group-text">분</span>
                    </div>
                </div>
                <p v-if="isFirst" class="text-success mt-2" style="font-size: 13px;">
                    봉사시간을 부여하면 참여완료 상태로 변경됩니다.
                </p>
            </div>

            <div class="vue-dialog-buttons">
                <button type="button" class="vue-dialog-button" style="flex: 1 1 50%;" @click="cancel()">취소</button>
                <button type="button" class="vue-dialog-button" style="flex: 1 1 50%; font-weight: 600;" @click="submit()">
                    {{ isFirst ? '부여' : '수정' }}
                </button>
            </div>
        </div>
    </modal>
</template>

<script>
    export default {
        name: "VolunteerMinuteModal",
        data() {
            return {
                article: {},
                minute: 0,
                isFirst: true,
                onSubmit: null,
                onCancel: null,
            }
        },
        methods: {
            beforeOpen(event) {
                this.article = event.params.article;
                this.minute = event.params.minute;
                this.isFirst = event.params.isFirst;
                this.onSubmit = event.params.onSubmit;
                this.onCancel = event.params.onCancel;
            },
            submit() {
                let value = parseInt(this.minute);
                if (isNaN(value) || value < 0) {
                    alert('0 이상의 숫자를 입력해주세요.');
                    return;
                }
                if (this.onSubmit) this.onSubmit(value);
                this.$modal.hide('VolunteerMinuteModal');
            },
            cancel() {
                if (this.onCancel) this.onCancel();
                this.$modal.hide('VolunteerMinuteModal');
            },
        },
    }
</script>

<style scoped>
    .popupcontainer {
        overflow-y: auto;
        border-radius: 5px;
        background: #F7F7F7;
        z-index: 1050;
        max-height: 70%;
    }
    .btn-close {
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        position: absolute;
        right: 20px;
        top: 5px;
    }
    .btn-close line {
        stroke: grey;
        stroke-width: 2;
    }
    .btn-close:hover line {
        stroke: black;
    }
    .modalHeader {
        border-bottom: 1px solid #EEE;
        padding: 1em;
        text-align: left;
    }
</style>
